import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link, Redirect} from "react-router-dom";
import MultiPageTemplate from '../../../components/MultiPagePDFReader';
import units from '../../../modals/d_channels_fac';

const duringLoad = <div className='loading-screen'>Loading the document</div>

const backLink = <div style={{padding: "12px 16px"}}>
  <Link to='/application/dashboard' style={{fontWeight: 600}}>← My Sessions</Link>
</div>;

let Book = class Book extends Component {
  render() {
    let {unitId} = this.props.match.params;
    let unit = units[unitId];
    if (!unit) {
      // Unknown guide id (e.g. an old or mistyped link): go back to the session list.
      return <Redirect to='/application/dashboard' />;
    }
    return <div>
      {backLink}
      <div id='_book_meta_cntr' className='_book_meta_cntr'>
        <MultiPageTemplate src={unit.src} duringLoad={duringLoad} docRatio={unit.docRatio || null}/>
      </div>
    </div>;
  }
}

const mapStateToProps = state => ({bookStore: state});
export default connect(mapStateToProps, null)(Book);
